<style lang="scss" scoped>
.writebacks {
	&__chart {
		margin-bottom: 30px;
	}
}
</style>

<template lang="pug">
.writebacks
    submenu
        writebacks-submenu
    .content
        page-header
            h1.highlight Writebacks
        page(v-loading="$apollo.loading")
            writebacks-chart(:startDate="startDate", :endDate="endDate").writebacks__chart
            writebacks-table(:startDate="startDate", :endDate="endDate", :show-school="true").writebacks__table
</template>

<script>
import moment from "moment";
import WritebacksSubmenu from "./includes/WritebacksSubmenu";
import WritebacksChart from "../writebacks/includes/WritebacksChart";
import WritebacksTable from "../writebacks/includes/WritebacksTable";

const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export default {
	name: "Writebacks",

	components: {
		WritebacksTable,
		WritebacksChart,
		WritebacksSubmenu
	},

	computed: {
		startDate() {
			return this.$route.query.start
				? moment.unix(this.$route.query.start).format(DATE_FORMAT)
				: moment
						.utc()
						.subtract(7, "days")
						.startOf("day")
						.format(DATE_FORMAT);
		},
		endDate() {
			return this.$route.query.end
				? moment.unix(this.$route.query.end).format(DATE_FORMAT)
				: moment
						.utc()
						.endOf("day")
						.format(DATE_FORMAT);
		}
	}
};
</script>
